import { createSelector } from 'reselect';
import { IFileCompareProps } from '../entities';
import { WebInterfaceBaseState } from 'common/base/state';
import ICompareObject from '../entities/ICompareObject';

const getTargetObjSelector = (state: WebInterfaceBaseState, props: IFileCompareProps) => {
	const targetObj =
		state.modules.dm.fileComparison.get(props.panelGuid)?.get('targetObj') || null;

	return targetObj;
};

export const getTargetObject = createSelector(
	[getTargetObjSelector],
	(targetObj: ICompareObject) => targetObj
);

const getSourceObjSelector = (state: WebInterfaceBaseState, props: IFileCompareProps) => {
	const sourceObj =
		state.modules.dm.fileComparison.get(props.panelGuid)?.get('sourceObj') || null;

	return sourceObj;
};

export const getSourceObject = createSelector(
	[getSourceObjSelector],
	(sourceObj: ICompareObject) => sourceObj
);
